import React from 'react'

const Stepper = ({ steps, activeStep }) => {
    const handleStepClick = (index, onClick) => {
        // Only allows you to click on steps prior to the current step
        if (index < activeStep) {
            onClick()
        }
    }

    return (
        <div className="custom-stepper">
            {steps.map((step, index) => {
                const isActive = index === activeStep
                const isCompleted = index < activeStep
                const isClickable = index < activeStep

                return (
                    <React.Fragment key={index}>
                        <div
                            className={`stepper ${isActive ? 'active' : ''} ${isCompleted ? 'completed' : ''} ${isClickable ? 'clickable' : 'disabled'}`}
                            onClick={() => handleStepClick(index, step.onClick)}
                        >
                            <div className="step-circle">
                                <span className="step-number">{index + 1}</span>
                            </div>
                            <div className="step-title">
                                <div>{step.title}</div>
                            </div>
                        </div>
                        {index < steps.length - 1 && <div className={`step-line ${isCompleted ? 'completed' : ''}`} />}
                    </React.Fragment>
                )
            })}
        </div>
    )
}

export default Stepper
